var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var WorkflowController = /** @class */ (function () {
    function WorkflowController() {
    }
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowDownloadDto}
    ******************************************************************************************************/
    WorkflowController.GetWorkflowForItem = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    WorkflowController.GetWorkflowStateForItem = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/users" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateUsersDownloadDto}
    ******************************************************************************************************/
    WorkflowController.GetWorkflowStateUsersForItem = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/users", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/approvals" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateApprovalDownloadDto[]}
    ******************************************************************************************************/
    WorkflowController.GetWorkflowStateApprovalsForItem = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/approvals", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/advance" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    WorkflowController.AdvanceWorkflow = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/advance", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/{approve}" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @param {boolean} approve
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    WorkflowController.ApproveWorkflowStep = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/{approve}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return WorkflowController;
}());
export { WorkflowController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=WorkflowController.js.map